import { useGetSpecialCategoriesQuery } from "../libs/specialCategory/api";

export const useIsCheckExercise = (specialCategoryId?: number): boolean => {
  const { data: categories } = useGetSpecialCategoriesQuery();
  if (!specialCategoryId || !categories) return false;
  const category = categories.find((c) => c.id === specialCategoryId);
  return category?.name?.toUpperCase().includes("CHECK") ?? false;
};
